/* @flow */

export const docSearchApiKey = 'bda3b62b0c5a0d2028abfaebbb651336';
export const docSearcIndexName = 'colony';
